import { RoleRoute } from './RoleRoute';

export { RoleRoute };
